// Números do site público (landing) — trocar aqui, não no JSX.
export const SITE = {
  PRECO_MENSAL: 67,
  PRECO_MENSAL_FORMATADO: 'R$ 67',
  TAREFAS_CASAMENTO: 196,
  TAREFAS_QUINZE_ANOS: 126,
  // Soma arredondada para baixo de TAREFAS_CASAMENTO + TAREFAS_QUINZE_ANOS (hoje 196+126=322).
  // Generalizado de propósito — o cronograma real de cada evento é um subconjunto
  // filtrado pelos serviços marcados no briefing, então o número aplicado varia
  // evento a evento; não prometer contagem exata. Revisar se o catálogo mudar bastante.
  TAREFAS_TOTAL_APROX: 300,
  ANOS_EXPERIENCIA: 13,
  DIAS_TRIAL: 14,
  DIGITOS_CODIGO_PORTAL: 6,
  ANO_PRECO_ATUAL: 2026,
} as const;

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_RULE_HINT = `Mínimo ${PASSWORD_MIN_LENGTH} caracteres, com pelo menos uma letra maiúscula, uma minúscula, um número e um símbolo (ex.: ! @ # $).`;

export const ESTADOS_BRASIL = [
  { uf: 'AC', nome: 'Acre' },
  { uf: 'AL', nome: 'Alagoas' },
  { uf: 'AP', nome: 'Amapá' },
  { uf: 'AM', nome: 'Amazonas' },
  { uf: 'BA', nome: 'Bahia' },
  { uf: 'CE', nome: 'Ceará' },
  { uf: 'DF', nome: 'Distrito Federal' },
  { uf: 'ES', nome: 'Espírito Santo' },
  { uf: 'GO', nome: 'Goiás' },
  { uf: 'MA', nome: 'Maranhão' },
  { uf: 'MT', nome: 'Mato Grosso' },
  { uf: 'MS', nome: 'Mato Grosso do Sul' },
  { uf: 'MG', nome: 'Minas Gerais' },
  { uf: 'PA', nome: 'Pará' },
  { uf: 'PB', nome: 'Paraíba' },
  { uf: 'PR', nome: 'Paraná' },
  { uf: 'PE', nome: 'Pernambuco' },
  { uf: 'PI', nome: 'Piauí' },
  { uf: 'RJ', nome: 'Rio de Janeiro' },
  { uf: 'RN', nome: 'Rio Grande do Norte' },
  { uf: 'RS', nome: 'Rio Grande do Sul' },
  { uf: 'RO', nome: 'Rondônia' },
  { uf: 'RR', nome: 'Roraima' },
  { uf: 'SC', nome: 'Santa Catarina' },
  { uf: 'SP', nome: 'São Paulo' },
  { uf: 'SE', nome: 'Sergipe' },
  { uf: 'TO', nome: 'Tocantins' }
] as const;

// Teste de 14 dias sem cartão (decisão de 30/09/2026).
export const TEXTO_TESTE_SEM_CARTAO = `${SITE.DIAS_TRIAL} dias grátis. Sem cartão.`;
export const TEXTO_TESTE_TERMINOU = `Seu teste terminou. Assine por ${SITE.PRECO_MENSAL_FORMATADO}/mês para voltar a editar e criar novos eventos. Tudo o que você fez está salvo.`;
export const TEXTO_COBRANCA_APOS_TESTE = 'Se você ainda está no teste, a primeira cobrança só acontece quando ele terminar. Cancele quando quiser.';

// Contato de suporte: WhatsApp (comunicado pelo dono em 30/09/2026; 8 dígitos após o DDD) + e-mail.
export const CONTATO_SUPORTE = {
  rotulo: 'WhatsApp (51) 9630-6885',
  href: 'https://wa.me/555196306885',
} as const;

export const CONTATO_EMAIL = {
  rotulo: 'contato@missaocerimonial.com.br',
  href: 'mailto:contato@missaocerimonial.com.br',
} as const;
